
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaitaxifare() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Taxi Fare',
        heading: 'Skyline Cabs: Pune to Mumbai Taxi Fare',
        headingDescription: 'Skyline Cabs offers competitive and transparent Pune to Mumbai Taxi Fare options. We ensure that you get the best value for your journey with no hidden charges. Whether you are traveling for business, leisure, or airport transfers, our affordable fares are designed to suit every budget. Enjoy a comfortable and hassle-free ride with Skyline Cabs, where punctuality, safety, and customer satisfaction are our top priorities. Book your Pune to Mumbai taxi today and experience reliable service at a fair price.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Pune to Mumbai Fare by Cab",
      "description": "Skyline Cabs offers competitive and transparent fare options for cab travel from Pune to Mumbai. Whether you choose a sedan, Ertiga, or Innova, our pricing is designed to fit different budgets without compromising on comfort or service quality. Get your exact fare with a quick quote."
    },
    {
      "name": "Pune to Mumbai Taxi Charges",
      "description": "Get fair and clear taxi charges for your Pune to Mumbai journey with Skyline Cabs. We provide upfront pricing with no hidden fees, and flexible options for one-way, round trip, and airport drop bookings across multiple vehicle categories."
    },
    {
      "name": "Taxi Fare from Pune to Mumbai Airport",
      "description": "Skyline Cabs offers fixed and affordable fares for airport transfers from Pune to Mumbai Airport. Our professional drivers ensure timely drop-offs, and our fleet includes everything from economy sedans to premium SUVs like the Innova Crysta."
    },
    {
      "name": "Pune to Mumbai Cheap Cabs",
      "description": "Looking for low-cost travel? Skyline Cabs provides cheap cab options from Pune to Mumbai without cutting corners on comfort or safety. Perfect for budget travelers and students, our fleet includes affordable hatchbacks and sedans."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Skyline Cabs is known as one of the best cab services from Pune to Mumbai. With well-maintained vehicles, polite drivers, and flexible booking options, we ensure a seamless and satisfying travel experience every time."
    },
    {
      "name": "Best Cab Service from Pune to Mumbai Airport",
      "description": "For a stress-free airport transfer, choose Skyline Cabs—the trusted name in Pune to Mumbai Airport taxi services. We specialize in timely pickups and drop-offs with clean, air-conditioned cabs and experienced drivers."
    },
    {
      "name": "Best Mumbai Pune Cab Service",
      "description": "Skyline Cabs delivers reliable and comfortable cab services between Mumbai and Pune. Whether it's a corporate ride or a family trip, we offer quality service, transparent pricing, and a choice of cars to match your travel needs."
    },
    {
      "name": "Best Pune to Mumbai Cab Service",
      "description": "Experience the best-in-class travel with Skyline Cabs. Our Pune to Mumbai cab service focuses on punctuality, comfort, and value for money. Choose from Ertiga, Innova, or premium sedans, with 24/7 booking support available."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Skyline Cabs offers Ertiga cabs for Pune to Mumbai trips—an ideal choice for families and groups. With extra space, comfortable seating, and affordable fares, the Ertiga provides great value for intercity travel."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Enjoy a smooth ride in an Innova with Skyline Cabs. Our Pune to Mumbai Innova cab service is perfect for those who prioritize space and comfort, especially for long-distance or group travel. Book now for a premium journey."
    },
    {
      "name": "Pune to Mumbai Round Trip Cab Fare",
      "description": "Skyline Cabs provides cost-effective round trip cab fares for Pune to Mumbai travel. Whether it's a single-day return or an extended stay, our pricing is flexible and offers value across all car types."
    },
    {
      "name": "Pune to Mumbai Shared Cab Fare",
      "description": "Travel affordably with Skyline Cabs’ shared cab option from Pune to Mumbai. Our shared ride service offers the best fares for those traveling alone or in pairs while still enjoying a clean, comfortable journey."
    },
    {
      "name": "Pune to Mumbai Innova Crysta Taxi Fare",
      "description": "Need a more luxurious ride? Skyline Cabs provides Innova Crysta taxi services from Pune to Mumbai with transparent and competitive fares. Perfect for corporate or family travel that needs extra comfort and elegance."
    },
    {
      "name": "Pune to Mumbai Airport Drop Innova Taxi Fare",
      "description": "Skyline Cabs offers fixed-rate Innova drops from Pune to Mumbai Airport. With comfortable interiors and ample luggage space, this is a great option for families and business travelers alike."
    },
    {
      "name": "Pune to Mumbai Ertiga Taxi Fare",
      "description": "Looking for a balance between comfort and cost? Skyline Cabs’ Ertiga taxi from Pune to Mumbai is priced to suit your budget while ensuring ample space and a relaxed journey."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Plan your travel efficiently with Skyline Cabs’ round trip cab services between Pune and Mumbai. Get reliable service, experienced drivers, and budget-friendly pricing, ideal for weekend returns or business commutes."
    },
    {
      "name": "Pune to Mumbai Skyline Cabs Taxi Fare",
      "description": "Skyline Cabs offers fully transparent and consistent taxi fare structures for trips between Pune and Mumbai. Choose your preferred vehicle and enjoy reliable pricing with no last-minute surprises."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Fare by Cab", "-Pune to Mumbai Taxi Charges"],
    ["Taxi Fare from Pune to Mumbai Airport", "-Pune to Mumbai Cheap Cabs"],
    ["Best Cab Service Pune to Mumbai", "-Best Cab Service from Pune to Mumbai Airport"],
    ["Best Mumbai Pune Cab Service", "-Best Pune to Mumbai Cab Service"],
    ["Pune to Mumbai Ertiga Cab", "-Pune to Mumbai Innova Cab"],
    ["Pune to Mumbai Round Trip Cab Fare", "-Pune to Mumbai Shared Cab Fare"],
    ["Pune to Mumbai Taxi Charges", "-Taxi Fare from Pune to Mumbai Airport"],
    ["Pune to Mumbai Innova Crysta Taxi Fare", "-Pune to Mumbai Airport Drop Innova Taxi Fare"],
    ["Pune to Mumbai Ertiga Taxi Fare", "-Pune to Mumbai Cab Round Trip"],
    ["Pune to Mumbai Skyline Cabs Taxi Fare", "-Pune to Mumbai Fare by Cab"]
  ],

  whychoose: [
    {
        "WhyChooseheading": "Affordable Pune to Mumbai Taxi Fare",
        "WhyChoosedescription": "Skyline Cabs offers highly competitive and affordable fares for your Pune to Mumbai taxi ride. We believe in delivering value without compromising on service quality, making your intercity journey budget-friendly and stress-free."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "With Skyline Cabs, what you see is what you pay. Our Pune to Mumbai taxi fare structure is completely transparent—no hidden fees, fuel surcharges, or last-minute additions. You’ll get a clear fare estimate before your trip even begins."
    },
    {
        "WhyChooseheading": "Flexible Fare Options to Suit Your Needs",
        "WhyChoosedescription": "Whether you’re booking a one-way ride, round trip, or need a cab by the hour, we offer flexible pricing plans tailored to your requirements. Choose the vehicle type and travel plan that fits your budget and schedule perfectly."
    },
    {
        "WhyChooseheading": "Fixed Rates for Peace of Mind",
        "WhyChoosedescription": "Our fixed fare options help you plan your expenses better. No surge pricing, no seasonal spikes—just honest, consistent rates that make Skyline Cabs the smart choice for travel between Pune and Mumbai."
    },
    {
        "WhyChooseheading": "Wide Range of Cabs at Different Price Points",
        "WhyChoosedescription": "From economical hatchbacks and sedans to spacious SUVs and luxury vehicles, our fleet caters to all kinds of travelers. No matter your budget, we have a comfortable and well-maintained taxi option for you."
    },
    {
        "WhyChooseheading": "24/7 Fare Support and Customer Assistance",
        "WhyChoosedescription": "Have questions about your fare or need help choosing the right plan? Our customer support team is available around the clock to guide you through your options and ensure you get the best value for your money."
    },
    {
        "WhyChooseheading": "No Extra Charges for Luggage or Route Flexibility",
        "WhyChoosedescription": "At Skyline Cabs, your comfort matters. We don’t charge extra for regular luggage, and our flexible routes mean you can make planned stops or detours without unexpected fare hikes."
    },
    {
        "WhyChooseheading": "Get Instant Fare Quotes Before Booking",
        "WhyChoosedescription": "Our website and app allow you to get a real-time taxi fare quote before confirming your booking. It’s quick, easy, and ensures full clarity—so you can travel between Pune and Mumbai with confidence and no surprises."
    }
]






    }


    const faqData = [
        {
            id: 1,
            question: 'What is the taxi fare from Pune to Mumbai with Skyline Cabs?',
            answer:
                'Skyline Cabs offers competitive and transparent pricing. The fare from Pune to Mumbai starts at ₹2499 for a sedan and varies based on the vehicle type, travel date, and any additional requirements like extra stops or luggage.',
        },
        {
            id: 2,
            question: 'Are there any hidden charges in the Pune to Mumbai taxi fare?',
            answer:
                'No, there are no hidden charges. Our pricing is transparent. Any tolls, taxes, or extra waiting charges are communicated to you upfront during booking.',
        },
        {
            id: 3,
            question: 'Does the fare include tolls and parking?',
            answer:
                'The base fare does not include tolls and parking fees. These are calculated based on actuals and added to the final bill. We ensure clarity and transparency in billing.',
        },
        {
            id: 4,
            question: 'What factors affect the Pune to Mumbai taxi fare?',
            answer:
                'The fare depends on the vehicle type (sedan, SUV, luxury), travel date/time (weekends or holidays may vary), duration of the ride, and any additional stops or detours you opt for.',
        },
        {
            id: 5,
            question: 'How do I get a fare estimate for my Pune to Mumbai trip?',
            answer:
                'You can get an instant fare estimate by entering your trip details on our website or app. Alternatively, call our customer service for a personalized fare quote.',
        },
        {
            id: 6,
            question: 'Is advance booking recommended to get the best taxi fare?',
            answer:
                'Yes, we recommend booking in advance to secure the best rates. Last-minute bookings may attract higher fares depending on demand and availability.',
        },
        {
            id: 7,
            question: 'Can I customize my ride and still get a fair taxi fare?',
            answer:
                'Absolutely. You can customize your trip with specific pickup points, detours, or return journeys. Our team will give you a fair and all-inclusive fare quote based on your itinerary.',
        },
        {
            id: 8,
            question: 'Do you offer flat-rate pricing for Pune to Mumbai rides?',
            answer:
                'Yes, we offer flat-rate pricing for standard routes. Contact us or check our website to see available flat fares for your route and vehicle category.',
        },
        {
            id: 9,
            question: 'Is there any fare difference between day and night travel?',
            answer:
                'Night charges may apply for rides starting after 10 PM or before 5 AM. These charges are clearly mentioned during booking and added to the final bill only if applicable.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Pune to Mumbai taxi fare transparency?',
            answer:
                'With Skyline Cabs, what you see is what you pay. We pride ourselves on upfront pricing, no hidden costs, and flexible packages. Our goal is to provide value for money with a reliable and comfortable ride.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Anil Patil",
            rating: 5,
            review: "Skyline Cabs offered the most reasonable Pune to Mumbai taxi fare compared to others. No surprises at the end — everything was communicated in advance. The ride was smooth, and the driver was very professional. Highly recommended!"
        },
        {
            name: "Miss. Rina Shah",
            rating: 4,
            review: "Good service and transparent pricing. I was traveling solo and was concerned about safety, but the driver was courteous and made me feel comfortable throughout the ride. The fare breakdown was clear and fair."
        },
    ];
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Taxi Fare",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-taxi-fare.jpg",
  "description": "Check affordable Pune to Mumbai taxi fare with Skyline Cabs. Transparent pricing, AC sedans and SUVs, professional drivers, and 24/7 service for all types of travelers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "8962"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1250",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-taxi-fare"
  }
};



      
    
      


    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Taxi Fare | Fixed Rates & 24x7 Service | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Check affordable Pune to Mumbai taxi fare with Skyline Cabs. Transparent pricing, AC sedans and SUVs, professional drivers, and 24/7 service for all types of travelers." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Taxi Fare, Pune Mumbai Cab Rates, One Way Taxi Fare Pune to Mumbai, AC Cab Fare Pune to Mumbai, Skyline Cabs Fare Chart, Sedan SUV Taxi Cost Pune Mumbai, Affordable Taxi Fare Pune to Mumbai, 24/7 Cab Service Pune to Mumbai, Fixed Price Cab Pune Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/6.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaitaxifare;